var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',[_c('img',{attrs:{"src":require("../common/images/newsir.gif"),"alt":""}}),_c('div',{staticClass:"content-text paddingT10 fontsize-20"},[_vm._v("努力开发中,敬请期待!")])])])
}]

export { render, staticRenderFns }